<template>
	<div class="ui-dialog modal is-active">
		<div class="modal-background" @click="onClose"></div>
		<div class="modal-card">
			<div class="ui-card" :style="`width: ${width}`">
				<ui-form @submit="onSubmit">
					<div class="ui-dialog-header p-4 ">
						<ui-title class="has-text-white">{{ title }}</ui-title>
						<span class="icon ui-dialog-closeBtn" @click="onClose">
							<i class="fas fa-times"></i>
						</span>
					</div>

					<slot name="nonWrappedBody"></slot>

					<div class="p-4" :class="defaultSlotContainerClassNames">
						<slot />
					</div>

	
					<div v-if="hasActions" class="ui-card-actions px-4 py-4">
						<slot name="actions" />
					</div>
				</ui-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			required: false
		},

		width: {
			type: String,
			default: '100%'
		},

		defaultSlotContainerClassNames: {
			type: String,
			default: ''
		}
	},

	computed: {
		hasActions() {
			return Boolean(this.$slots.actions);
		}
	},

	methods: {
		onSubmit() {
			this.$emit('submit');
		},

		onClose() {
			this.$emit('close');
		}
	}
};
</script>

<style lang="scss">
.ui-dialog-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: #23282d;
}

.ui-dialog-closeBtn {
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: lighten(#23282d, 5%);
	border-radius: 50%;
	width: 30px !important;
	height: 30px !important;
	transition: background-color 0.3s ease;

	&:hover {
		transition: background-color 0.3s ease;
		background-color: lighten(#23282d, 10%);
	}
}

.modal-card {
	max-height: 80vh;
	margin-top: 3rem !important;
}
</style>
